'use strict';

import React from 'react';
import PropTypes from 'prop-types'
import classnames from "classnames";

import {isFalse, stripQueryParams} from '@uw-it-sis/lib-react/lib/Utils';
import appStore from '@uw-it-sis/lib-react/lib/AppStore';

import {MetricLabels, MetricKeys} from './Constants';
import OrgUtils from "./OrgUtils";

const analyticsStore = appStore.getAnalyticsStore();

const AppNavigationLink = ({children, href = "", compareLocation = '', className = '', unauthenticated = false}) => {

    const handleClick = function() {
        document.body.classList.remove("nav-expanded");
        const pageHeading = document.querySelector("main h1");
        if (pageHeading) {
            pageHeading.setAttribute("tabindex", "-1");
            pageHeading.focus();
        }

        // fall back to the url if we can't map it to a page
        let dest = OrgUtils.getPageFromUrl(href, appStore.getApplicationName()) || href;

        // Add analytics for any global nav usage.
        const labels = analyticsStore.label(MetricLabels.navLinkDestName, dest).add(MetricLabels.navType, "global").get();
        analyticsStore.addEvent(MetricKeys.navigation, labels, {});
    };

    /*
     * If not authenticated and the link is flagged as having unauthenticated access enabled, return text instead of a link.
     */
    if (isFalse(unauthenticated) && ! appStore.isAuthenticated()) {
        return (
            <span className="unauthenticated">{children}</span>
        );
    }

    let active = stripQueryParams(href) === compareLocation;

    return (
        <a href={href} onClick={handleClick} className={classnames(className, {"active": active})}>
            {children}
        </a>
    );
};

AppNavigationLink.propTypes = {
    href: PropTypes.string.isRequired,
    compareLocation: PropTypes.string.isRequired,  // string to compare against href for highlighting
    className: PropTypes.string,
    unauthenticated: PropTypes.bool
};

export default AppNavigationLink;
